import { ResponsiveContainer, BarChart, Bar, Cell, XAxis, YAxis, Tooltip } from "recharts";
import { ChartCard } from "./Card";
import { styles, tokens } from "./styles";

// Headline percentile + a histogram of the cohort's standardized-score
// distribution, with the candidate's bucket highlighted. Renders nothing until
// the cohort is large enough (the parent decides visibility).
export function standingVisible(data) {
  return Boolean(data?.available);
}

export default function StandingCard({ data, scopeLabel }) {
  if (!standingVisible(data)) return null;

  const { your_percentile, your_score, cohort_size, distribution } = data;

  return (
    <ChartCard title="Where you stand" hint={`Among ${cohort_size} ${scopeLabel}`}>
      <div style={styles.bigStat}>{your_percentile}<span style={{ fontSize: 18 }}>th</span></div>
      <p style={styles.bigStatCaption}>
        percentile — you scored <strong>{your_score}%</strong>, ahead of {your_percentile}% of the cohort.
      </p>

      <ResponsiveContainer width="100%" height={180}>
        <BarChart data={distribution} margin={{ top: 4, right: 8, left: -20, bottom: 0 }}>
          <XAxis dataKey="bucket" tick={{ fontSize: 10, fill: tokens.ink400 }} interval={0} angle={-30} textAnchor="end" height={42} />
          <YAxis allowDecimals={false} tick={{ fontSize: 10, fill: tokens.ink400 }} />
          <Tooltip
            cursor={{ fill: tokens.surface }}
            formatter={(value) => [`${value} candidate${value === 1 ? "" : "s"}`, "Count"]}
            labelFormatter={(label) => `Score ${label}`}
          />
          <Bar dataKey="count" radius={[3, 3, 0, 0]}>
            {distribution.map((d, i) => (
              <Cell key={i} fill={d.is_you ? tokens.accent : tokens.ink300} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>

      <div style={styles.legend}>
        <span><span style={styles.legendDot(tokens.accent)} />Your bucket</span>
        <span><span style={styles.legendDot(tokens.ink300)} />Cohort</span>
      </div>
    </ChartCard>
  );
}
